import React, { useState, useEffect, useContext } from "react";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import Input from "@material-ui/core/Input";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Enlace from "@material-ui/core/Link";
import { Link } from "react-router-dom";
import Paper from "@material-ui/core/Paper";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Particles from "react-tsparticles";
import AuthContext from "../../Context/autenticacion/authContext";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import InputAdornment from "@material-ui/core/InputAdornment";
import MerryLogo from "../../assets/img/merry.png";

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      <Enlace color="inherit" href="https://www.digital-pineapple.com.mx">
        By Digital-Pineapple
      </Enlace>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100vh",
  },
  image: {
    backgroundColor: "#000000",
    height: "100vh",
    position: 'relative',
    overflow: 'hidden',
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  paper: {
    margin: theme.spacing(0, 4),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    height: "100%",
    justifyContent: "center",
    [theme.breakpoints.down('xs')]: {
      margin: theme.spacing(0, 2),
    },
  },
  logo: {
    margin: theme.spacing(1),
    width: 200,
    height: 'auto',
    marginBottom: theme.spacing(3)
  },
  form: {
    width: "100%",
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: '#000',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#333'
    }
  },
}));

const Login = (props) => {
  const classes = useStyles();

  const authContext = useContext(AuthContext);
  const { autenticado, verifyRecaptcha, iniciarSesion } = authContext;
  const { executeRecaptcha } = useGoogleReCaptcha();

  const [usuario, guardarUsuario] = useState({
    email: "",
    password: "",
  });
  const { email, password } = usuario;

  const onChange = (e) => {
    guardarUsuario({
      ...usuario,
      [e.target.name]: e.target.value,
    });
  };

  const [values, setValues] = useState({
    password: "",
    showPassword: false,
  });

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handlePasswordChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
    guardarUsuario({
      ...usuario,
      [event.target.name]: event.target.value,
    });
  };

  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!executeRecaptcha) {
      console.log("reCAPTCHA aún no está listo");
      return;
    }
    setLoading(true);
    const recaptchaToken = await executeRecaptcha("login");
    // El backend valida el token internamente en el método login, si lo validados
    // antes con verifyRecaptcha() entonces Google lanzará un error de token duplicado.
    iniciarSesion({ email, password, recaptcha_token: recaptchaToken });
  };

  useEffect(() => {
    if (autenticado) {
      props.history.push("/");
    }
    if (localStorage.getItem("token")) {
      props.history.push("/");
    }
  }, [autenticado, props.history]);

  useEffect(() => {
    if (!autenticado) {
      setLoading(false);
    }
  }, [autenticado]);

  return (
    <Grid container component="main" className={classes.root}>
      <CssBaseline />
      {/* Left Panel — Particles */}
      <Grid item xs={false} sm={4} md={7} className={classes.image}>
        <Particles
          id="tsparticles"
          style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }}
          options={{
            fpsLimit: 60,
            interactivity: {
              detectsOn: "canvas",
              events: {
                onClick: { enable: true, mode: "push" },
                onHover: { enable: true, mode: "grab" },
                resize: true,
              },
              modes: {
                grab: {
                  distance: 200,
                  links: { opacity: 0.5 },
                },
                push: { quantity: 4 },
              },
            },
            particles: {
              color: { value: "#ffffffff" },
              links: {
                color: "#ffffff",
                distance: 150,
                enable: true,
                opacity: 0.5,
                width: 1,
              },
              collisions: { enable: true },
              move: {
                direction: "none",
                enable: true,
                outMode: "bounce",
                random: false,
                speed: 0.5,
                straight: false,
              },
              number: { density: { enable: true, value_area: 800 }, value: 80 },
              opacity: { value: 0.5 },
              shape: { type: "circle" },
              size: { random: true, value: 5 },
            },
            detectRetina: true,
          }}
        />
      </Grid>

      {/* Right Panel — Form */}
      <Grid
        item
        xs={12}
        sm={8}
        md={5}
        component={Paper}
        elevation={6}
        square
      >
        <div className={classes.paper}>
          {/* Logo */}
          <img src={MerryLogo} alt="Merrycolor" className={classes.logo} />

          <form className={classes.form} onSubmit={onSubmit}>
            {/* Email */}
            <TextField
              margin="normal"
              type="email"
              required
              fullWidth
              id="email"
              label="Correo Electrónico"
              name="email"
              autoComplete="email"
              autoFocus
              value={email}
              onChange={onChange}
            />

            {/* Password */}
            <Input
              margin="normal"
              required
              type={values.showPassword ? "text" : "password"}
              fullWidth
              name="password"
              placeholder="Contraseña"
              id="password"
              autoComplete="current-password"
              value={values.password}
              onChange={handlePasswordChange("password")}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                  >
                    {values.showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              }
            />

            <FormControlLabel
              control={<Checkbox value="remember" color="primary" />}
              label="Recordar mi contraseña"
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              className={classes.submit}
              disabled={loading}
            >
              {loading ? "Iniciando sesión..." : "Iniciar Sesión"}
            </Button>

            <Grid container justify="center">
              <Grid item>
                <Link to="/password/forgot" style={{ color: "#000" }}>
                  ¿Olvidaste tu contraseña?
                </Link>
              </Grid>
            </Grid>

            <Box mt={5}>
              <Copyright />
            </Box>
          </form>
        </div>
      </Grid>
    </Grid>
  );
};

export default Login;